<template>

  <div style="max-width: 560px; min-width: 400px;">

    <v-toolbar
      floating
      :flat="isFlat"
      width="100%"
      style="z-index: 8001 !important;"
      class="pa-2 position-relative"
    >

<!--      <template v-slot:extension v-if="recentSearches.length">-->

<!--        <v-layout align="center" @click="addressQuery" class="mt-4">-->

<!--          <v-flex sm3 class="mr-2">Recent:</v-flex>-->
<!--          <v-flex>-->
<!--            <v-chip v-for="(item, key) in recentSearches"-->
<!--                    :key="key"-->
<!--                    x-small-->
<!--                    class="mr-1 mb-1"-->
<!--                    outlined-->
<!--                    label-->
<!--                    close-->
<!--                    @click="search = item"-->
<!--                    @click:close="removeRecent(item)">-->
<!--              {{item}}-->
<!--            </v-chip>-->
<!--          </v-flex>-->
<!--        </v-layout>-->
<!--      </template>-->

      <v-menu v-model="candidatesMenuOpen" offset-y :nudge-bottom="70" :nudge-left="24" full-width
              nudge-width="48">

        <template v-slot:activator="{ on }">

          <v-text-field
            @input="addressQuery"
            v-model="search"
            v-on="on"
            placeholder="Address Search"
            prepend-icon="mdi-magnify"
            autofocus
            clearable
            :loader-height="4"
            persistent-hint
            hint="Enter an address to find service(s)"
            :loading="searching"
          ></v-text-field>

        </template>

        <v-list dense style="max-height: 400px;" class="overflow-y-auto" v-if="items.length">
          <v-subheader>Address Search Candidates</v-subheader>
          <template v-for="(item, index) in items"
          >
            <v-list-item :key="index"
                         @click="selectItem(item)"
            >
              <v-list-item-content>
                <v-list-item-title>
                  <v-layout align-center>
                    <v-flex xs2>
                      <v-chip class="d-block text-center"
                              label
                              :color="getScoreColor(item.score)"
                      >{{Math.round(item.score)}}
                      </v-chip>
                    </v-flex>
                    <v-flex xs9 offset-1 class="text-truncate">{{item.address}}</v-flex>
                  </v-layout>
                </v-list-item-title>
              </v-list-item-content>
            </v-list-item>
            <v-divider :key="`divider-${index}`" v-show="index !== items.length - 1"></v-divider>
          </template>
        </v-list>
      </v-menu>

    </v-toolbar>

  </div>

</template>

<script>
import debounce from 'lodash/debounce';
import uniqBy from 'lodash/uniqBy';
import orderBy from 'lodash/orderBy';

export default {

  name: 'AddressSearch',

  props: {
    isFlat: {
      type: Boolean,
      default: false,
    },
  },

  data() {
    return {
      search: process.env.NODE_ENV === 'development' ? '' : '',
      candidatesMenuOpen: false,
      searching: false,
      recentSearches: process.env.NODE_ENV === 'development' ? [
        '3747 Crowley Lake',
        '3 Orchard Rd',
        '437 Old Mammoth',
      ] : [],
      candidates: [],
      selectedAddress: null,
    };
  },

  mounted() {
    // this.addressQuery();
  },

  watch: {

    search() {
      // this.addressQuery();
      if (!this.search) {
        this.candidates = [];
      }
    },

    items(val) {
      this.candidatesMenuOpen = val.length !== 0;
    },

    selectedAddress(val) {
      this.$emit('address-selected', val);
    },

  },

  computed: {

    items() {
      const uniqueCandidates = uniqBy(this.candidates, 'address');
      return orderBy(uniqueCandidates, [
        'score',
        'attributes.Loc_name',
        'attributes.StName',
        'attributes.StType',
        'attributes.SubAddUnit',
      ], [
        'desc',
        'asc',
        'asc',
        'asc',
        'asc',
      ]);
    }

  },

  methods: {

    selectItem(item) {
      this.search = item.address;
      this.selectedAddress = item;
      this.recentSearches.push(item.address);
      this.recentSearches = this.recentSearches.slice(0, 5);
    },

    removeRecent(recentItem) {
      const i = this.recentSearches.findIndex(item => item === recentItem);
      this.recentSearches.splice(i, 1);
    },

    addressQuery: debounce(async function () {
      const minLength = 3;
      const searchAlreadyDone = this.selectedAddress === this.search;
      const searchStringInadequate = !this.search || this.search.length <= minLength;
      if (searchAlreadyDone || searchStringInadequate) return;
      this.searching = true;
      this.candidates = [];
      this.selectedAddress = null;
      this.candidates = await this.$helpers.requests.findAddressCandidates(this.search);
      this.searching = false;
    }, 300),

    getScoreColor(value) {
      return value > 90
        ? 'green white--text' : value > 80
          ? 'lime lighten-1' : 'deep-orange lighten-1 white--text';
    },

  },

};
</script>
